import { Action } from '@ngrx/store';
import { LineInterface } from '../../models/line.interface';

export enum ELinesActions {
  GetLines = '[LINE] Get lines',
  GetLinesSuccess = '[LINE] Get lines success',
  GetLinesFailure = '[LINE] Get lines failure'
}

export class GetLines implements Action {
  public readonly type = ELinesActions.GetLines;
  constructor() {}
}

export class GetLinesSuccess implements Action {
  public readonly type = ELinesActions.GetLinesSuccess;
  constructor(public payload: Array<LineInterface>) {}
}

export class GetLinesFailure implements Action {
  public readonly type = ELinesActions.GetLinesFailure;
}

export type LinesActions = GetLines | GetLinesSuccess | GetLinesFailure;
